function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/* Taken from https://dmitripavlutin.com/how-to-compare-objects-in-javascript/ */


export function deepEqual(object1, object2) {
  var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var keys1 = Object.keys(object1),
      keys2 = Object.keys(object2);

  if (strict && keys1.length !== keys2.length) {
    return false;
  }

  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val1 = object1[key],
        val2 = object2[key];
    var areObjects = isObject(val1) && isObject(val2);

    if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2) {
      return false;
    }
  }

  return true;
}

function isObject(object) {
  return object != null && _typeof(object) === 'object';
} // (c) Tim Down & community (CC BY-SA 2.5)
// https://stackoverflow.com/a/2838358


export function selectElementText(element) {
  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = win.document;
  var sel, range;

  if (win.getSelection && doc.createRange) {
    sel = win.getSelection();
    range = doc.createRange();
    range.selectNodeContents(element);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (doc.body.createTextRange) {
    range = doc.body.createTextRange();
    range.moveToElementText(element);
    range.select();
  }
}
export var NS = 'http://www.w3.org/2000/svg';
export var createSVGElement = function createSVGElement(tag) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = document.createElementNS(NS, tag);
  Object.entries(attributes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return element.setAttributeNS(null, key, value);
  });
  return element;
};
export var removeAccents = function removeAccents(text) {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
export var tokenizeText = function tokenizeText(text) {
  var r = /([^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+)/g;
  return text.split(r);
};
export var normalizeTextToken = function normalizeTextToken(token) {
  return removeAccents(token).toLowerCase();
};
export var tokenizeAndNormalizeText = function tokenizeAndNormalizeText(text) {
  return tokenizeText(text).filter(function (_, i) {
    return i % 2 === 0;
  }).map(normalizeTextToken).filter(function (s) {
    return s;
  });
};